import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "loading", "disabled", "invalid", "inline", "leftAdornment", "rightAdornment", "inputRef", "size", "onChange", "width", "minWidth", "maxWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { InputWrapper } from '../../../internal/components/InputWrapper/InputWrapper';
import { InputWrapperInput } from '../../../internal/components/InputWrapperInput/InputWrapperInput';
import { FocusObserver } from '../../../internal/components/FocusObserver/FocusObserver';
import { FocusSource } from '../../../internal/types';
import { jsx as _jsx } from "react/jsx-runtime";
var InputComponent = /*#__PURE__*/React.forwardRef(function Input(props, ref) {
  var _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    leftAdornment = props.leftAdornment,
    rightAdornment = props.rightAdornment,
    inputRef = props.inputRef,
    size = props.size,
    onChange = props.onChange,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState({
      focused: false,
      source: FocusSource.mouse
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focus = _React$useState2[0],
    setFocus = _React$useState2[1];
  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e, e.currentTarget.value);
    }
  };
  var handleFocus = function handleFocus(focused, source) {
    setFocus({
      focused: focused,
      source: source
    });
  };
  return /*#__PURE__*/_jsx(InputWrapper, {
    ref: ref,
    focused: focus.focused,
    focusSource: focus.source,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    leftAdornment: leftAdornment,
    rightAdornment: rightAdornment,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    children: /*#__PURE__*/_jsx(FocusObserver, {
      onFocus: handleFocus,
      children: /*#__PURE__*/_jsx(InputWrapperInput, _objectSpread(_objectSpread({}, rest), {}, {
        type: type,
        ref: inputRef,
        disabled: disabled,
        onChange: handleChange
      }))
    })
  });
});
export var Input = /*#__PURE__*/React.memo(InputComponent);